import {
    Positionable,
    SimpleReelModelDelegate,
    SimpleReelModelEventData,
    SimpleReelModelState,
    SimpleReelModelSymbolData,
    SimpleReelModelSymbolPosition
} from "../../core/reel/simplereel/SimpleReelModel";
import {FreespinSymbol} from "./FreespinSymbol";
import {SimpleSpinReelModel} from "../../core/reel/simplereel/SimpleSpinReelModel";
import {LayersSet} from "./LayersSet";
import {DevilsCrossRoad} from "../DevilsCrossRoad";
import {gsap} from "gsap";
import {DevilsCrossRoadSymbolState} from "../symbol/DevilsCrossRoadSymbolConfig";
import {DevilsCrossRoadGameConfig} from "../DevilsCrossRoadGameConfig";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";


export class DevilsCrossRoadFreespinReel implements SimpleReelModelDelegate {

    public id:number;
    public model:SimpleSpinReelModel;
    public layers:LayersSet;
    private _maskGfx:PIXI.Graphics;
    private _pendBlinkOverlay:PIXI.Sprite;

    public position:PIXI.ObservablePoint;

    public static reelConversion: PIXI.Point [] = [
        // 0-5
        new PIXI.Point(0,0), new PIXI.Point(0,1), new PIXI.Point(0,2), new PIXI.Point(0,3), new PIXI.Point(0, 4), new PIXI.Point(0,5),
        // 6 - 11
        new PIXI.Point(1, 0), new PIXI.Point(1, 1), new PIXI.Point(1, 2), new PIXI.Point(1, 3), new PIXI.Point(1, 4), new PIXI.Point(1, 5),
        // 11-16
        new PIXI.Point(2, 0), new PIXI.Point(2, 1), new PIXI.Point(2, 2), new PIXI.Point(2, 3), new PIXI.Point(2, 4), new PIXI.Point(2, 5),
        // 17 - 22
        new PIXI.Point(3, 0), new PIXI.Point(3,1), new PIXI.Point(3,2), new PIXI.Point(3,3), new PIXI.Point(3, 4), new PIXI.Point(3, 5),
        // 23 - 28
        new PIXI.Point(4, 0), new PIXI.Point(4, 1), new PIXI.Point(4, 2), new PIXI.Point(4, 3), new PIXI.Point(4, 4), new PIXI.Point(4, 5),
        // 29 - 34
        new PIXI.Point(5, 0), new PIXI.Point(5, 1), new PIXI.Point(5, 2), new PIXI.Point(5, 3), new PIXI.Point(5, 4), new PIXI.Point(5, 5)
    ];

    private spinAnimation:gsap.core.Timeline;
    private activePendingHighlight:gsap.core.Timeline;

    constructor(id:number) {
        this.position = new PIXI.ObservablePoint(this.onPosition, this);
        //this.pivot = new PIXI.ObservablePoint(this.onPivot, this);
        //this.scale = new PIXI.ObservablePoint(this.onScale, this);
        const hack:any = NolimitApplication.pixiApp.renderer.mask;
        hack.enableScissor = true;

        this.id = id;

        this.model = new SimpleSpinReelModel(id, this, true);
        this.model.illegalVisualPaddingSymbols = []; //["W4", "S", "P", "S2", "XW", "XS"];

        if(DevilsCrossRoadGameConfig.FS_FEATURE_RIDS.indexOf(this.id) > -1) {
            this.model.setReelSet(DevilsCrossRoadGameConfig.FS_TMP_FEATURE_REEL_SET);
        }
        else {
            this.model.setReelSet(DevilsCrossRoadGameConfig.FS_TMP_DEFAULT_REEL_SET);
        }
        //this.model.stepDuration = DeadCanaryStatics.stepDuration;
        //this.model.stepSize = DeadCanaryStatics.freespinStepSize;

        this.model.events?.on(SimpleReelModelState.START, (data:SimpleReelModelEventData) => {
            for(let symbolData of this.model.symbols) {
                (<FreespinSymbol>symbolData.positionable).getStateAnimation(DevilsCrossRoadSymbolState.NORMAL);
            }
        });

        this.model.events?.on(SimpleReelModelState.BOUNCE, (data:SimpleReelModelEventData) => {
            //this.stop();
            //Switches state of all symbols from spin state to normal, when the symbols bounce.
            const allVisible = this.model.getAllVisibleSymbols();
            for(let symbolData of allVisible) {
                (<FreespinSymbol>symbolData.positionable).getStateAnimation(DevilsCrossRoadSymbolState.LANDING);
                symbolData.reelId;
                symbolData.reelPosition;
            }

        });
        this.model.events?.on(SimpleReelModelState.SPIN, (data:SimpleReelModelEventData) => {
            //this.start();
            //Switches state of all symbols from whatever state to spin when reel wind up is done and the spinning starts.
            for(let symbolData of this.model.symbols) {
                (<FreespinSymbol>symbolData.positionable).getStateAnimation(DevilsCrossRoadSymbolState.SPIN);
            }
        });


        this.layers = new LayersSet(`reel_${this.id}_`);
        this._maskGfx = this.createMask(0, 5, 150/*DevilsCrossRoadGameConfig.FS_SYMBOL_WIDTH*/, DevilsCrossRoadGameConfig.FS_SYMBOL_HEIGHT);

        this.layers.maskedNormal.addChild(this._maskGfx);
        this.layers.maskedNormal.mask = this._maskGfx;
        //this.layers.maskedNormal.mask.rend;

        this.layers.maskedOver.mask = this._maskGfx;
        this.layers.maskedHighlight.mask = this._maskGfx;


        this.createFeaturePendingBlink();
    }

    public playHighlightAndPend(loop:boolean = false): void {
        //this._pendBlinkOverlay.visible = true;
        //this.activePendingHighlight = gsap.timeline({repeat:-1}).add(this.blinkHighlight());
        const sym:FreespinSymbol = <FreespinSymbol>this.model.getVisibleSymbolAt(0).positionable;
        if(sym) {
            if(loop) {
                sym.playCoinHighlightLoop();
            }
            else {
                sym.playCoinHighlightRadial();
            }
        }
    }

    public stopHighlightLoop(): void {
        //this._pendBlinkOverlay.visible = true;
        //this.activePendingHighlight = gsap.timeline({repeat:-1}).add(this.blinkHighlight());
        const sym:FreespinSymbol = <FreespinSymbol>this.model.getVisibleSymbolAt(0).positionable;
        if(sym) {
            sym.fadeCoinHighlightLoopAndStop();
        }
    }

    public stopHighlight():void {
        if(this.activePendingHighlight) {
            this.activePendingHighlight.pause();
            this.activePendingHighlight.kill();
            this._pendBlinkOverlay.alpha = 0;
            this._pendBlinkOverlay.visible = false;
        }
    }

    public blinkHighlight(): TimelineMax {
        /*
       TweenVars
                    delay?: TweenValue;
                    duration?: TweenValue;
                    ease?: string | EaseFunction;
                    endArray?: any[];
                    immediateRender?: boolean;
                    lazy?: boolean;
                    keyframes?: TweenVars[] | object;
                    onInterrupt?: Callback;
                    onInterruptParams?: any[];
                    overwrite?: "auto" | boolean;
                    runBackwards?: boolean;
                    stagger?: NumberValue | StaggerVars;
                    startAt?: TweenVars;
                    yoyoEase?: boolean | string | EaseFunction;

         */

        const tl: gsap.core.Timeline = gsap.timeline({
            yoyo: true,
            paused: true
        });

        if(this._pendBlinkOverlay) {
            tl.add(gsap.fromTo(this._pendBlinkOverlay, {
                alpha: 0.7,
                duration: 0.035
            }, {
                alpha: 0
            }));
            tl.add(gsap.fromTo(this._pendBlinkOverlay, {
                alpha: 0.7,
                duration:  0.035
            }, {
                alpha: 0
            }));
        }


        return tl.play();
    }

    private createFeaturePendingBlink(): void {
        const symWidth:number = DevilsCrossRoadGameConfig.FS_SYMBOL_WIDTH;
        const symHeight:number = DevilsCrossRoadGameConfig.FS_SYMBOL_HEIGHT;
        this._pendBlinkOverlay = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._pendBlinkOverlay.width = symWidth + 5;
        this._pendBlinkOverlay.height = symHeight;
        this._pendBlinkOverlay.tint = 0xDC143C;
        this._pendBlinkOverlay.alpha = 0;
        this._pendBlinkOverlay.x = 10;

        this.layers.win.addChild(this._pendBlinkOverlay);
    }

    public addDebugTint(): void {
        const sprite:PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
        sprite.width = DevilsCrossRoadGameConfig.FS_SYMBOL_WIDTH;
        sprite.height = DevilsCrossRoadGameConfig.FS_SYMBOL_HEIGHT;

        if(this.id % 2 === 0) {
            sprite.tint = 0xFFCCCCC;
        }
        else {
            sprite.tint = 0xCCCCCFF;
        }

        sprite.alpha = 0.2;

        this.layers.maskedNormal.addChild(sprite);
    }

    private createMask(x:number, y:number, width:number, height:number):PIXI.Graphics {
        const normalPolygon:PIXI.Point[] = [ // TODO Just do a rectangle
            new PIXI.Point(1, 0),
            new PIXI.Point(2, 1),
            new PIXI.Point(1, 2),
            new PIXI.Point(0, 1)
        ];

        for (let i:number = 0; i < normalPolygon.length; i++) {
            //normalPolygon[i] = MathUtils.multiplyPoints(normalPolygon[i], new PIXI.Point(DeadCanaryStatics.SYMBOL_WIDTH_FS * 0.5, DeadCanaryStatics.SYMBOL_HEIGHT_FS * 0.5));
            //normalPolygon[i].x -= DeadCanaryStatics.SYMBOL_WIDTH_FS * 0.5;
            //normalPolygon[i].y -= DeadCanaryStatics.SYMBOL_HEIGHT_FS * 0.5;
        }

        const mask = new PIXI.Graphics();
        mask.beginFill(0xffffff,0.3);
        mask.drawRect(x, y, width, height);
        //mask.drawPolygon(normalPolygon);
        mask.endFill();
        //mask.enableScissor = true;

        return mask;
    }

    public set fSReelVisible(visible:boolean) {
        this.layers.all.forEach((layer) => {
            layer.visible = visible;
        });
    }

    show():void {
        this.layers.show();
    }

    hide():void {
        this.layers.hide();
    }

    hideMaskedNormal():void {
        //this.layers.hideMaskedNormal();
    }

    showMaskedNormal():void {
        this.layers.showMaskedNormal();
    }

    createSymbol(symbolName: string, state: SimpleReelModelState, position: SimpleReelModelSymbolPosition, goatTease:boolean = false): Positionable {
        const symbolState:DevilsCrossRoadSymbolState = (state == SimpleReelModelState.SPIN || state == SimpleReelModelState.STOP) ? DevilsCrossRoadSymbolState.SPIN : DevilsCrossRoadSymbolState.NORMAL;
        let symName:string = "X";

        if(symbolName === "CX" || symbolName === "C" || symbolName.indexOf("F") > -1) {
            symName = symbolName;

            if(symbolName === "F") {
                symName = "F" + Math.floor(Math.random() * (10 - 1) + 1).toString();
            }
        }

        const symbol = new FreespinSymbol(symName, symbolState, this, goatTease);
        if(state === SimpleReelModelState.SPIN) {
            this.layers.maskedOver.addChild(symbol);
        }
        else {
            this.layers.maskedNormal.addChild(symbol);
        }

        if(symbolName === "CX" || symbolName === "C") {
            if(state === SimpleReelModelState.STOP || state === SimpleReelModelState.STICKY) {
                const rID: number = position.reelID;
                const val: number = (DevilsCrossRoad.model.data.stickyCoinsValuesBeforeFeature[DevilsCrossRoadFreespinReel.reelConversion[rID].x][DevilsCrossRoadFreespinReel.reelConversion[rID].y])?
                    DevilsCrossRoad.model.data.stickyCoinsValuesBeforeFeature[DevilsCrossRoadFreespinReel.reelConversion[rID].x][DevilsCrossRoadFreespinReel.reelConversion[rID].y] : 1;
                symbol.addAndShowValueLabel(val.toString());
            }
            else if(state === SimpleReelModelState.STOPPED) {
                const rID: number = position.reelID;
                const val: number = (DevilsCrossRoad.model.data.stickyCoinsValuesBeforeFeature[DevilsCrossRoadFreespinReel.reelConversion[rID].x][DevilsCrossRoadFreespinReel.reelConversion[rID].y])?
                    DevilsCrossRoad.model.data.stickyCoinsValuesBeforeFeature[DevilsCrossRoadFreespinReel.reelConversion[rID].x][DevilsCrossRoadFreespinReel.reelConversion[rID].y] : 1;
                symbol.addAndShowValueLabel(val.toString());
            }
            else if(state === SimpleReelModelState.SPIN) {

                // If feature slots

                const validValues: string [] = ["1","5","20","100"];
                symbol.addAndShowValueLabel(validValues[this.randomNumber(0, 4)].toString());
            }
        }

        return symbol;
    }

    private randomNumber(min:number, max:number):number {
        return Math.floor(Math.random() * (max - min) + min);
    }

    removeSymbol(symbolData: SimpleReelModelSymbolData): void {
        (<FreespinSymbol>symbolData.positionable).destroy();
    }

    removeSymbolReset(symbolData: SimpleReelModelSymbolData, textureResets:boolean = false): void {
        if(textureResets) {
            (<FreespinSymbol>symbolData.positionable).resetTextures();
        }
        (<FreespinSymbol>symbolData.positionable).destroy();
    }

    private onPosition() {
        for(let layer of this.layers.all) {
            layer.position.set(this.position.x, this.position.y);
        }
    }

    public init(reelData:string[], goatReset:boolean = false) {
        this.model.paddingConfig.visualPaddingBefore = 1;
        this.model.paddingConfig.paddingBefore = 0;
        this.model.paddingConfig.visibleSymbols = 1;
        this.model.paddingConfig.paddingAfter = 0;
        this.model.paddingConfig.visualPaddingAfter = 2;

        this.model.init(reelData, goatReset);
    }

    public reInitReel(reelData:string[], goatReset:boolean = true) {
        this.model.reInit(reelData, goatReset);
    }

    public start() {
        const tl:gsap.core.Timeline = gsap.timeline();

        //tl.add(gsap.to(this.layers.maskedNormal, {duration : 1, alpha : 0.8, ease : "power3.out"}));

        if(this.model.state === SimpleReelModelState.STICKY || this.model.state === SimpleReelModelState.STOPPED) {
            tl.add(gsap.to(this.layers.maskedNormal, {duration : 0.1, alpha : 0.8, ease : "power3.out"}));
        }
        else{
            tl.add(gsap.to(this.layers.maskedNormal, {duration: 1, alpha: 0.8, ease: "power3.out"}));
        }
        this.spinAnimation = tl;
    }

    private stop() {
        this.spinAnimation.kill();
        gsap.to(this.layers.maskedNormal, {duration : 0.1, alpha : 1});
    }


}